import { searchCommonConfig } from './common'

/**
 * Storlyn 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: 'rgba(243, 166, 192, 0.08)',
    startReadingBg: 'linear-gradient(90deg, #FF81B0 0%, #EE3BA4 100%)',
    isLight: true,
    cardPadding: '0',
    cardBorder: 'none',
    cardBg: 'transparent',
  },
}
